/**
 * Eventos sin endpoint guardados en el dispositivo por guestCode (inventario D22): "ya hemos salido",
 * hora de llegada, recomendación descartada, consentimientos… Se enviarán cuando exista el endpoint;
 * la UI los trata como hechos. Sin almacenamiento disponible, se ignora en silencio.
 */
const PREFIX = 'v2.local.'

type Store = Record<string, unknown>

function read(guestCode: string): Store {
  try {
    const raw = localStorage.getItem(PREFIX + guestCode)
    return raw ? (JSON.parse(raw) as Store) : {}
  } catch {
    return {}
  }
}

export function readLocal<T>(guestCode: string, field: string): T | null {
  const value = read(guestCode)[field]
  return value === undefined ? null : (value as T)
}

export function writeLocal(guestCode: string, field: string, value: unknown): void {
  try {
    const store = read(guestCode)
    if (value === null || value === undefined) delete store[field]
    else store[field] = value
    localStorage.setItem(PREFIX + guestCode, JSON.stringify(store))
  } catch {
    /* sin almacenamiento */
  }
}
